import React from 'react'
import { Control, Controller, ControllerRenderProps } from 'react-hook-form'
import {
  KeyboardDatePicker,
  KeyboardDatePickerProps,
} from '@material-ui/pickers'
import { useTranslation } from 'react-i18next'

type Props = Omit<
  KeyboardDatePickerProps,
  | 'value'
  | 'onChange'
  | 'emptyLabel'
  | 'okLabel'
  | 'cancelLabel'
  | 'clearLabel'
  | 'format'
> & {
  control: Control
  name: string
  label: string
  defaultValue?: Date
  fullWidth?: boolean
  dataCy?: string
}

export function ControlledDatePicker(props: Props): React.ReactElement {
  const {
    control,
    name,
    label,
    defaultValue,
    fullWidth,
    dataCy,
    ...inputProps
  } = props
  const { t } = useTranslation()

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue ?? null}
      render={({
        value,
        onChange,
      }: Omit<ControllerRenderProps, 'value'> & { value: Date }) => (
        <KeyboardDatePicker
          {...inputProps}
          fullWidth={fullWidth ?? false}
          format={t('date.date')}
          value={value}
          onChange={onChange}
          label={label}
          emptyLabel=""
          okLabel={t('common.ok')}
          cancelLabel={t('common.cancel')}
          clearLabel={t('common.clear')}
          data-cy={dataCy}
        />
      )}
    />
  )
}
